

import React from 'react';

class BaseFilterPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: ''
        }
    }

    handleInputBlur = (value) => {
        this.setState({ inputValue: value });
    };

    componentDidMount(){
        this.fetchData();
    }

    componentDidUpdate(props, state) {
        if (state.inputValue !== this.state.inputValue) {
            this.fetchData(this.state.inputValue);
        }
    }

    fetchData(inputText) {
        // To be implemented by inheriting class
    }

}

export default BaseFilterPage;
